import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=380ed655&scoped=true"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"
import style0 from "./Sort.vue?vue&type=style&index=0&id=380ed655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_css-loader@6.11.0_webpack@5.94.0__handlebar_6db25a2d12e0482dcbfee89f46ef6b8e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ed655",
  null
  
)

export default component.exports